import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { HashRouter as Router } from 'react-router-dom'
import { Switch, Route } from 'react-router'

import Form from 'Tyan/public/components/Form/Form'
import { getQuery, WX, setLoginToken } from 'tyan/public'
import Message from 'tyan/public/components/Message'
import NoMatch404 from 'tyan/public/components/Layout/NoMatch404'
import lazy from 'tyan/components/Lazy'

import ContractQuery from './Weixin/ContractQuery'
import ReportQuery from './Weixin/ReportQuery'
import InstrumentQuery from './Weixin/InstrumentQuery'

import PlanStart from './Weixin/PlanStart'
import DataEntry from './Weixin/DataEntry'
import DataReview from './Weixin/DataReview'
import ReportReview from './Weixin/ReportReview'
import ReportApproval from './Weixin/ReportApproval'
import SpotCheckTask from './Weixin/SpotCheckTask'

import InstrumentUsageQuery from './Weixin/InstrumentUsageQuery'
import InstrumentUsageInfo from './Weixin/InstrumentUsageInfo'

import DailyTaskStatus from './Weixin/DailyTaskStatus'
import DailyTaskTobeProcessed from './Weixin/DailyTaskTobeProcessed'
import DailyTaskToBeConfirmed from './Weixin/DailyTaskToBeConfirmed'
import DailyTaskHandleOfThe from './Weixin/DailyTaskHandleOfThe'
import DailyTaskHasBeenCompleted from './Weixin/DailyTaskHasBeenCompleted'

//数据引用审批
import QuoteDataApproval from './Weixin/QuoteData/QuoteDataApproval'
import QuoteDataApprovalInfo from './Weixin/QuoteData/QuoteDataApprovalInfo'

//排工审核
import SchedulingAudit from './Weixin/Schedule/SchedulingAudit'
import SchedulingAuditInfo from './Weixin/Schedule/SchedulingAuditInfo'

//详情页面
import DetailContract from './Weixin/DetailContract'
import DetailReport from './Weixin/DetailReport'
import PlanDetailData from './Weixin/PlanDetailData'
import PlanStartInfo from './Weixin/PlanStartInfo'
import DetailData from './Weixin/DetailData'
import DataEntryInfo from './Weixin/DataEntryInfo'
import InspectionDeviceInfo from './Weixin/InspectionDeviceInfo'
import DataReviewInfo from './Weixin/DataReviewInfo'
import ReportReviewInfo from './Weixin/ReportReviewInfo'
import ReportApprovalInfo from './Weixin/ReportApprovalInfo'
import ReportApprovalTime from './Weixin/ReportApprovalTime'
import DailyTaskInfo from './Weixin/DailyTaskInfo'
import SpotPlanInfo from './Weixin/SpotPlanInfo'
import InspectionDeviceInfoBatch from './Weixin/InspectionDeviceInfoBatch'
import SpotPlanExecute from './Weixin/SpotPlanExecute'
import InstrumentInfo from './Weixin/InstrumentInfo'
import { doGetCodeInfo, doLoginLims, doGetJSSDKSignatureInfo } from 'tyan/reducers/actions'

class WeixinLayout extends React.Component {
	state = {
		userName: null,
		loadJSSDK: false,// true,
		errorMessage: null,
	}
	componentDidMount() {
		const { doGetCodeInfo, doLoginLims, doGetJSSDKSignatureInfo } = this.props
		const code = getQuery(location.search, 'code') // 'WXXDATEQD3654WEF2S.DF16WE56.21F11211'
		doGetCodeInfo({
			code,
			onSuccess: () => {
				doLoginLims({
					code,
					onFailure: ({ errorMessage }) => {
						this.setState({ errorMessage: '登录错误: ' + errorMessage })
					},
					onSuccess: ({ userName, token }) => {
						setLoginToken(token)
						this.setState({ userName })
						// 测试
						doGetJSSDKSignatureInfo({
							url: location.origin + location.pathname + location.search,
							onFailure: ({ errorMessage }) => {
								this.setState({ errorMessage: '获取签名错误: ' + errorMessage })
							},
							onSuccess: ({ appId, timestamp, nonceStr, signature }) => {
								WX.config({
									beta: true,// 必须这么写，否则wx.invoke调用形式的jsapi会有问题
									debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
									appId, // 必填，企业微信的corpID
									timestamp, // 必填，生成签名的时间戳
									nonceStr, // 必填，生成签名的随机串
									signature,// 必填，签名，见 附录-JS-SDK使用权限签名算法
									jsApiList: ['chooseImage', 'uploadImage', 'downloadImage', 'scanQRCode', 'getLocation', 'getLocalImgData', 'startRecord', 'stopRecord', 'onVoiceRecordEnd', 'playVoice', 'pauseVoice', 'stopVoice', 'onVoicePlayEnd', 'uploadVoice', 'downloadVoice'] // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
								}, () => {
									// alert('wx.ready')
									this.setState({ loadJSSDK: true })
								}, (res) => {
									this.setState({ errorMessage: 'JSSDK注册错误: ' + JSON.stringify(res) })
									// alert(JSON.stringify(res))
								})
							}
						})
						// 测试
					}
				})
			},
			onFailure: ({ errorMessage }) => {
				this.setState({ errorMessage: '登录失败: ' + errorMessage })
			}
		})
	}
	render() {
		const { loadJSSDK, errorMessage, userName } = this.state
		if (errorMessage) {
			return <Message text="数据加载失败" subtext={errorMessage} />
		} else if (userName && loadJSSDK) {
			return (
				<Router>
					<Switch>
						{/* 数据查询—合同查询、报告查询 */}
						<Route exact path="/QYWX/ContractQuery" component={ContractQuery} />
						<Route exact path="/QYWX/ReportQuery" component={ReportQuery} />
						{/* 检测管理—开始计划、数据录入、数据审核、报告审批、数据引用审批 */}
						<Route exact path="/QYWX/PlanStart" component={PlanStart} />
						<Route exact path="/QYWX/DataEntry" component={DataEntry} />
						<Route exact path="/QYWX/DataReview" component={DataReview} />
						<Route exact path="/QYWX/ReportReview" component={ReportReview} />
						<Route exact path="/QYWX/ReportApproval" component={ReportApproval} />
						<Route exact path="/QYWX/QuoteDataApproval" component={QuoteDataApproval} />
						{/* 设备管理—设备资料查询、设备点检、设备使用、排工审核 */}
						<Route exact path="/QYWX/InstrumentQuery/:query" component={InstrumentQuery} />
						<Route exact path="/QYWX/SpotCheckTask/:query" component={SpotCheckTask} />
						<Route exact path="/QYWX/InstrumentUsageQuery/:query" component={InstrumentUsageQuery} />
						<Route exact path="/QYWX/InstrumentUsageInfo/:query/:id" component={InstrumentUsageInfo} />
						<Route exact path="/QYWX/SchedulingAudit" component={SchedulingAudit} />

						<Route exact path="/QYWX/DailyTaskStatus/:dailyTaskID" component={DailyTaskStatus} />
						<Route exact path="/QYWX/DailyTaskTobeProcessed" component={DailyTaskTobeProcessed} />
						<Route exact path="/QYWX/DailyTaskToBeConfirmed" component={DailyTaskToBeConfirmed} />
						<Route exact path="/QYWX/DailyTaskHandleOfThe" component={DailyTaskHandleOfThe} />
						<Route exact path="/QYWX/DailyTaskHasBeenCompleted" component={DailyTaskHasBeenCompleted} />

						<Route exact path="/QYWX/DetailContract/:contractID" component={DetailContract} />
						<Route exact path="/QYWX/DetailReport/:reportID" component={DetailReport} />
						<Route exact path="/QYWX/PlanDetailData/:contractID" component={PlanDetailData} />
						<Route exact path="/QYWX/PlanStartInfo/:planID" component={PlanStartInfo} />
						<Route exact path="/QYWX/DetailData/:sampleID/:itype" component={DetailData} />
						<Route exact path="/QYWX/DataEntryInfo/:sampleInspectionID" component={DataEntryInfo} />
						<Route exact path="/QYWX/InspectionDeviceInfo/:sampleInspectionID/:inspectionDeviceID" component={InspectionDeviceInfo} />
						<Route exact path="/QYWX/InspectionDeviceInfoBatch/:sampleInspectionID" render={props => <InspectionDeviceInfoBatch {...props} showBody={Form} />} />
						<Route exact path="/QYWX/DataReviewInfo/:sampleInspectionID" component={DataReviewInfo} />
						<Route exact path="/QYWX/ReportReviewInfo/:reportID" component={ReportReviewInfo} />
						<Route exact path="/QYWX/ReportApprovalInfo/:reportID" component={ReportApprovalInfo} />
						<Route exact path="/QYWX/ReportApprovalTime/:reportID" component={ReportApprovalTime} />
						<Route exact path="/QYWX/DailyTaskInfo/:dailyTaskID/:itype" component={DailyTaskInfo} />
						<Route exact path="/QYWX/SpotPlanInfo/:id" render={props => <SpotPlanInfo {...props} showBody={Form} />} />
						<Route exact path="/QYWX/SpotPlanExecute/:id" render={props => <SpotPlanExecute {...props} showBody={Form} />} />
						<Route exact path="/QYWX/InstrumentInfo/:id" render={props => <InstrumentInfo {...props} showBody={Form} />} />
						<Route exact path="/QYWX/QuoteDataApprovalInfo/:id" render={props => <QuoteDataApprovalInfo {...props} showBody={Form} />} />
						<Route exact path="/QYWX/SchedulingAuditInfo/:id" render={props => <SchedulingAuditInfo {...props} showBody={Form} />} />
						<Route component={NoMatch404} />
					</Switch>
				</Router>
			)
		} else if (!userName) {
			return <Message text="数据加载" subtext={'登录中...'} />
		} else if (!loadJSSDK) {
			return <Message text="数据加载" subtext={'注册JSSDK中...'} />
		} else {
			return <Message text="数据加载" subtext={'未知的状态...'} />
		}
	}
}

const mapStateToProps = ({ loginInfo: { userName } }) => ({
	userName,
})

export default compose(
	connect(mapStateToProps, { doGetCodeInfo, doLoginLims, doGetJSSDKSignatureInfo }),
)(WeixinLayout)